import { AxiosResponse } from 'axios';
import { apiClient, getAuthHeaders } from './index';
import { TokenState } from './types';

export const monitoringApi = {
  /**
   * 모니터링 결과 노트를 업데이트합니다.
   * @param tokenAddress 토큰 주소
   * @param index 모니터링 결과 인덱스 (0-based)
   * @param note 모니터링 노트
   * @returns 업데이트된 Token State
   */
  async updateMonitoringNote(
    tokenAddress: string,
    index: number,
    note: string
  ): Promise<TokenState> {
    try {
      const response: AxiosResponse<any> = await apiClient.patch(
        `/fe-management-system/token-states/${tokenAddress}/monitoring/${index}/note`,
        { note },
        {
          headers: getAuthHeaders(),
        }
      );

      return response.data.data;
    } catch (error) {
      console.error('❌ PATCH /fe-management-system/token-states/:tokenAddress/monitoring/:index/note 에러:', error);
      throw error;
    }
  },
  /**
   * 모니터링 결과에 평가자의 의견을 기록합니다.
   * @param tokenAddress 토큰 주소
   * @param index 모니터링 결과 인덱스 (0-based)
   * @param payload 평가자의 이름, 항목, 댓글
   * @returns 업데이트된 Token State
   */
  async updateMonitoringOpinion(
    tokenAddress: string,
    index: number,
    payload: {
      name: string;
      items: Array<{ type: string; score: number }>;
      comment?: string;
    }
  ): Promise<TokenState> {
    try {
      const response: AxiosResponse<any> = await apiClient.patch(
        `/fe-management-system/token-states/${tokenAddress}/monitoring/${index}/opinion`,
        payload,
        {
          headers: getAuthHeaders(),
        }
      );

      return response.data.data;
    } catch (error) {
      console.error('❌ PATCH /fe-management-system/token-states/:tokenAddress/monitoring/:index/opinion 에러:', error);
      throw error;
    }
  },
  /**
   * Auto monitoring 상태를 토글합니다.
   * @param tokenAddress 토큰 주소
   * @returns 업데이트된 Token State
   */
  async toggleAutoMonitoring(tokenAddress: string): Promise<TokenState> {
    try {
      const response: AxiosResponse<any> = await apiClient.patch(
        `/fe-management-system/token-states/${tokenAddress}/auto-monitoring`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data.data;
    } catch (error) {
      console.error(
        '❌ PATCH /fe-management-system/token-states/:tokenAddress/auto-monitoring 에러:',
        error,
      );
      throw error;
    }
  },
};
